import React, {useEffect, useState} from 'react';
import {useObserver} from "mobx-react";
import {Draggable} from "react-beautiful-dnd";
import Overlay from "./Overlay";
import {useStores} from "../../../../stores/Context";
import FormatageDate from "../Composants/FormatageDate";
import IconeStatut from "../Icone/IconeStatut";
import BtnSvg from "../../../../boiteAOutils/BtnSvg";
import ModalPrimary from "../../../../boiteAOutils/ModalPrimary";
import BtnTiertary from "../../../../boiteAOutils/BtnTiertary";
import CorbeilleSvg from "../../../../boiteAOutils/SVG/CorbeilleSvg";

const Archive = ({isDragging}) => {
    const {PlanningActionsStore} = useStores();

    const tachesArchivees = useObserver(() => PlanningActionsStore.taches_archivees);

    // État pour gérer le modal de confirmation et la tâche sélectionnée
    const [selectedTaskId, setSelectedTaskId] = useState(null);

    const handleClose = () => {
        PlanningActionsStore.closeModal();
    };

    const handleMenuDelete = (tacheId, event) => {
        event.stopPropagation();
        setSelectedTaskId(tacheId); // Définir l'ID de la tâche pour suppression
    };

    const confirmDeleteTask = () => {
        if (selectedTaskId) {
            PlanningActionsStore.deleteTacheToDatabase(selectedTaskId); // Suppression de la tâche dans la base de données
            setSelectedTaskId(null); // Réinitialise l'état après suppression
        }
    };

    const cancelDeleteTask = () => {
        setSelectedTaskId(null); // Ferme le modal sans valider
    };

    return (
        <Overlay titre={"Actions archivées"} onClose={handleClose} className={"archive"} width={"400px"}>
            {tachesArchivees.map((tacheArchivee, index) => (
                <Draggable key={tacheArchivee.id} draggableId={tacheArchivee.id} index={index}>
                    {(provided, snapshot) => {
                        // extending the DraggableStyle with our own inline styles
                        const style = {
                            ...provided.draggableProps.style,
                            //boxShadow: snapshot.isDragging ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            //userSelect: "none",
                            //width: snapshot.isDragging ? "" : "100%",
                            //height: snapshot.isDragging ? "" : "auto"
                        };

                        return (
                            <div className={"flex gap-2"}>
                                <div className={'tache'}
                                     ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                     style={style}>
                                    <div className={"iconeTitre"}>
                                        <IconeStatut icone={tacheArchivee.statut?.icone || 'Rond'} couleur={tacheArchivee.statut?.couleur || '#FFF'}/>
                                        <div className={"titre"}>
                                            {tacheArchivee.titre}
                                            {(tacheArchivee.planning_id !== tacheArchivee.planning_createur) && (
                                                <div
                                                    className={"planningCreateur"}>{tacheArchivee.planning_createur_nom}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {!snapshot.isDragging &&
                                    <div className={"date"}>
                                        Date de creation: <FormatageDate date={tacheArchivee.created_at}/>
                                        <br/>Date d’archive : <FormatageDate date={tacheArchivee.date_archivage}/>
                                        <br/>
                                        <br/>
                                        <BtnTiertary onClick={(event) => handleMenuDelete(tacheArchivee.id, event)}><CorbeilleSvg couleur={"var(--icon-dark)"}/> Supprimer</BtnTiertary>
                                    </div>
                                }
                            </div>
                        );
                    }}
                </Draggable>
            ))}
            {/* Modal de confirmation de suppression */}
            {selectedTaskId && (
                <ModalPrimary
                    textTitle="Confirmer la suppression"
                    textComment="Êtes-vous sûr de vouloir supprimer définitivement cette tâche ?"
                    textBtnValidate="Supprimer"
                    textBtnCancel="Annuler"
                    onValidate={confirmDeleteTask}
                    onCancel={cancelDeleteTask}
                />
            )}
        </Overlay>
    );
};

export default Archive;
